<template>
  <Modal v-model="goMakeThePaymentModal" :title="$t('key1000609')" width="750" :transfer="false"
    :mask-closable="false" @on-visible-change="goMakeThePaymentChange">
    <h2 class="mb20">{{ $t('key1006089') }}</h2>
    <div class="table_box mt20">
      <Table
        highlight-row
        border
        max-height="560"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <template #footer>
      <Button class="mr15" @click="goMakeThePaymentModal = false">{{ $t('key1000248') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getDataSetBatchList, getEnumName} from "@/utils/common";

export default {
  name: 'goMakeThePaymentModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      goMakeThePaymentModal: false,
      tableColumns: [
        {
          title: 'NO',
          width: 70,
          align: 'center',
          type: 'index'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522'),
          key: 'packageCode',
          minWidth: 110,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003599'),
          key: 'orderAmount',
          align: 'center',
          minWidth: 110,
          render(h, params) {
            let totalPrice = params.row.totalPrice;
            let totalPriceCurrency = params.row.totalPriceCurrency;
            let text = totalPriceCurrency + ' ' + totalPrice;
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006081'),
          key: 'orderAmount',
          align: 'center',
          minWidth: 110,
          render(h, params) {
            let payStatus = params.row.payStatus;
            let text = getEnumName(v.enumData, 'YmsPlatformOrderShippingPayStatusDistributorEnum', payStatus, 'number');
            return h('span', {class: payStatus === 1 ? 'crimsonRedColor' : ''}, text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'center',
          width: 110,
          render(h, params) {
            let ymsPackageId = params.row.ymsPackageId;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006082'),
                    show: true,
                    clickFn: () => {
                      let extendJson = params.row.extendJson;
                      if (extendJson) {
                        let obj = JSON.parse(extendJson);
                        if (obj.payUrl) {
                          window.open(obj.payUrl, '_blank');
                        }
                      }
                      v.goMakeThePaymentBtn(ymsPackageId, params.index);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006083'),
                    show: true,
                    clickFn: () => {
                      v.updateStatusBtn(ymsPackageId, params.index);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      enumData: []
    };
  },
  methods: {
    // 初始化数据
    async initGoMakeThePaymentData(obj) {
      this.tableData = [];
      this.enumData = await getDataSetBatchList(['YmsPlatformOrderShippingPayStatusDistributorEnum']);
      let ymsPlatformOrderPackageRelateds = obj.ymsPlatformOrderPackageRelateds || [];
      ymsPlatformOrderPackageRelateds.map((item) => {
        if (item.ymsPackageInfo && item.ymsPackageInfo.status !== 8) {
          let obj = {
            ...item.ymsPackageInfo,
            packageCode: item.packageCode
          };
          this.tableData.push(obj);
        }
      });
      this.goMakeThePaymentModal = true;
    },
    // 去付款
    goMakeThePaymentBtn(ymsPackageId, index) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006084'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006085'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000608'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          v.axios.put(api.put_ymsPlatformOrder_markUpdateOrderStatus + ymsPackageId, null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              let data = res.data.datas;
              if (data) {
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000608'));
                v.$emit('updateData', true);
                v.$set(v.tableData[index], 'payStatus', 2);
                v.$forceUpdate();
              } else {
                v.updateStatusBtn(ymsPackageId, index);
              }
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 更新状态
    updateStatusBtn(ymsPackageId, index) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006086'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006087'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006088'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006013'),
        onOk: () => {
          v.axios.put(api.put_ymsPlatformOrder_paymentSuccess + ymsPackageId, null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
              v.$emit('updateData', true);
              let data = res.data.datas;
              if (data) {
                v.$set(v.tableData[index], 'payStatus', 2);
                v.$forceUpdate();
              }
            }
          });
        },
        onCancel: () => {
          setTimeout(() => {
            v.goMakeThePaymentBtn(ymsPackageId, index);
          }, 1500);
        }
      });
    },
    // 监听弹窗
    goMakeThePaymentChange(value) {
      if (!value) {
        this.tableData = [];
      }
    }
  }
};
</script>

<style lang="less">

</style>
